export const SHALLOW_GRAPH_VERSION = '4.1.0';
